/**
 * 빈 객체 여부를 반환
 * @param obj
 * @returns {boolean}
 */
export const isEmptyObject = (obj) => {
  if (!obj) return true
  return obj?.constructor === Object && Object?.keys(obj).length === 0
}
